import {
  arrayRemoveAll,
  reset,
  setSubmitFailed,
  startSubmit,
  stopSubmit,
} from 'redux-form';
import { all, call, put, select } from 'redux-saga/effects';
import { requestForSaga } from 'utils/request/request';
import { requestCustomErrorMessage } from 'utils/request/requestCustomErrorMessage';
import { requestMessage } from 'utils/request/requestMessage';
import { ADD_IPS, CLEAR_IPS, FETCH_IPLIST } from './constants';

import { validation } from '@ipfabric/utils';
import { takeEvery } from 'containers/ErrorBoundary';
import { closeDialogue } from 'containers/LeaveDialogue/actions';
import ipNet from 'ip';
import { push } from 'redux-first-history';

const isValid = (item) => {
  if (!item) {
    return false;
  }
  if (ipNet.isV4Format(item)) {
    return true;
  }
  try {
    const result = validation.cidr.validate(item);
    return !result.error;
  } catch {
    return false;
  }
};

export function* fetchIpListSaga() {
  try {
    // used in Wizard Configuration only
    const ipList = yield call(requestForSaga, {
      url: '/settings/seed',
      method: 'GET',
    });
    yield put({
      type: `${FETCH_IPLIST}_SUCCESS`,
      payload: {
        ipList,
      },
    });
  } catch (e) {
    yield call(requestCustomErrorMessage, 'danger', e);
    throw e;
  }
}

function* addIpsSaga(action) {
  const { ips, returnUrl, formName } = action.payload;
  try {
    yield put(startSubmit(formName));
    yield call(requestForSaga, {
      url: '/settings/seed',
      method: 'PUT',
      data: ips,
    });
    yield call(requestMessage, 'success', 'seedIpSave');
    yield put({
      type: `${ADD_IPS}_SUCCESS`,
      payload: ips,
    });
    if (returnUrl) {
      const { state = {} } = returnUrl;
      yield put(
        push(
          { pathname: returnUrl.pathname, search: returnUrl.search },
          { ...state },
        ),
      );
    }
    yield put(stopSubmit(formName));
    yield put(reset(formName));
  } catch (e) {
    const leaveDialogueOpen = yield select((s) =>
      s.getIn(['leaveDialogue', 'open']),
    );
    if (leaveDialogueOpen) {
      yield put(closeDialogue());
    }
    yield call(requestCustomErrorMessage, 'danger', e);
    yield put(setSubmitFailed(formName));
    yield put(stopSubmit(formName));
    throw e;
  }
}

function* clearIpsSaga(action) {
  try {
    const { system, formName } = action.payload;
    const ipList = yield select((state) =>
      state.getIn(['form', formName, 'values', 'ip']),
    );
    if (system) {
      yield call(requestForSaga, {
        url: '/settings/seed',
        method: 'DELETE',
        data: ipList.toJS().filter(isValid),
      });
      yield call(requestMessage, 'success', 'seedIpClearIps');
    }
    yield put(arrayRemoveAll(formName, 'ip'));
    yield put({
      type: `${CLEAR_IPS}_SUCCESS`,
    });
  } catch (e) {
    yield call(requestCustomErrorMessage, 'danger', e);
    throw e;
  }
}

export function* defaultSaga() {
  yield all([
    takeEvery(FETCH_IPLIST, fetchIpListSaga),
    takeEvery(ADD_IPS, addIpsSaga),
    takeEvery(CLEAR_IPS, clearIpsSaga),
  ]);
}

export default defaultSaga;
